// extracted by mini-css-extract-plugin
export default {"cardsContainer":"CardsApp_cardsContainer__Bf6oK","cards":"CardsApp_cards__41qa-","card":"CardsApp_card__40YJS","text_card":"CardsApp_text_card__2CpDo","icon":"CardsApp_icon__EXN4O"};